import { render } from "./ServiceFormEditDialog.vue?vue&type=template&id=5394a5a4&scoped=true"
import script from "./ServiceFormEditDialog.vue?vue&type=script&lang=js"
export * from "./ServiceFormEditDialog.vue?vue&type=script&lang=js"

import "./ServiceFormEditDialog.vue?vue&type=style&index=0&id=5394a5a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5394a5a4"]])

export default __exports__